<template>
    <div class="markWap">
        <!-- <div class="markWapTopBox">
            <h5>{{enterpriseDetail.name}}</h5>
            <div class="bagesBox">
                <div class="localBage line_border_blue">{{enterpriseDetail.regionName}}</div>
                <div class="industryBage line_border_green">{{enterpriseDetail.industryCategoryName}}</div>
            </div>
        </div> -->
        <div class="markWapTopBox line_bottom">
            <p class="title">{{enterpriseDetail.name}}</p>
            <div class="bagesBox">
                <div class="localBage">{{enterpriseDetail.regionName}}</div>
                <div class="industryBage">{{enterpriseDetail.industryCategoryName}}</div>
            </div>
        </div>
        <div class="markList">
            <div class="markItem line_bottom">
                <div class="markTitle">扣分原因<span>&#42;</span></div>
                <div class="markSelect" @click="suitCause">
                    <div v-if="!markCause || markCause === ''" class="item"><span>请选择</span></div>
                    <div class="item" v-else><span class="markColor">{{markCause}}</span></div>
                    <img src="../../../../assets/image/inner_icon_select.png" class="icon_right"/>
                </div>
            </div>
            <div class="markItem line_bottom">
                <div class="markTitle">详细类型<span>&#42;</span></div>
                <div class="markSelect" @click="suitType">
                    <div v-if="!markType || markType === ''" class="item"><span>请选择</span></div>
                    <div class="item"  v-else><span class="markColor">{{markType}}</span></div>
                    <img src="../../../../assets/image/inner_icon_select.png" class="icon_right"/>
                </div>
            </div>
            <div class="markItem line_bottom">
                <div class="markTitle">违规违法日期<span>&#42;</span></div>
                <!-- <div class="markSelect" @click="suitDay"> -->
                <div class="markSelect" @click="showDatePicker">
                    <div v-if="!markDay || markDay === ''" class="item"><span>请选择</span></div>
                    <div class="item"  v-else><span class="markColor">{{markDay}}</span></div>
                    <img src="../../../../assets/image/inner_icon_select.png" class="icon_right"/>
                </div>
            </div>
            <div class="markItem line_bottom">
                <div class="markTitle">扣分值</div>
                <div class="markSelect">
                    <div :class="markNum === ''?'markSelectItem':'markColor'">{{markNum === ''?'-- --':markNum}}<span v-if="markNum != ''">分</span></div>
                </div>
            </div>
        </div>
        <div class="markDetail">
            <div class="markTitle">违法违规详情</div>
            <div class="markRemack">
                <textarea
                    class="markRemackBox"
                    v-model="message"
                    placeholder="请在这里补充违规违法详情"
                ></textarea>
            </div>
        </div>
        <div class="markUpload">
            <div class="markFuil">
                <upload :imgUrl="imgUrl" :fileSource='1' :fileBizType='6'></upload>
            </div>
        </div>
        <div class="btnWap">
            <div class="submitBtn" @click="submitBtn">
                提交
            </div>
        </div>

        <van-popup
            class="popWap"
            v-model="show"
            position="bottom"
            :style="{ height: '42%' }"
            >
            <div class="radioGroupBox">
                <van-RadioGroup v-model="radio" class="popBox">
                    <CellGroup title="选择扣分原因">
                        <cell
                            v-for="(item, index) in list"
                            :key="index"
                            :title="item.groupName"
                            @click="handleClickRadio(index,item.groupName)"
                        >
                            <van-Radio slot="right-icon" :name="item.groupName" />
                        </cell>
                    </CellGroup>
                </van-RadioGroup>
            </div>
            <div class="btnWap">
                <div class="submitBtn" @click="submitTabBtn">确认</div>
            </div>
        </van-popup>
        <common-picker ref="commonPicker2" :typeList="detailList" v-if='compickFlag' :cols="colsDetail" @getTypeValue="typeListDetail"></common-picker>
        <van-popup
            class="popBox"
            v-model="isShowTimePicker"
            position="bottom"
            :style="{ height: '40%' }"
        >
            <time-PickerFB @getDate="getDate" @cancelDatePick="cancelDatePick"/>
        </van-popup>
        <timePick @getTimeValue="getTimeValue" ref="timePick"></timePick>
    </div>
</template>

<script>
    import commonPicker from '../../../../components/base/commonPicker'
    import TimePickerFB from '../../components/TimePickerFB'
    import timePick from '../../../../components/base/timePick'
    import Upload from '../../components/Upload'
    import api from '../../../../service/modules/integrity'

    export default {
        components: {
            commonPicker,
            timePick,
            Upload,
            TimePickerFB
        },
        data () {
            return {
                // 是否展开时间选择器
                isShowTimePicker: false,
                markCause: '',
                markType: '',
                markTypeIndex: '',
                markDay: '',
                markNum: '',
                message: '',
                compickFlag: false,
                // causeList: [], // 没用
                colsCause: 1, // 没用
                // 详细类型列表
                detailList: [],
                colsDetail: 1,
                show: false,
                result: [], // 暂时不确定
                // 扣分原因列表
                list: [],
                // ICE
                enterpriseId: '',
                radio: '',
                listIndex: '',
                // 上传绑定的IMG数组
                imgUrl: [],
                //  提交按钮需求参数
                enterpriseGradeId: '',
                normalDetailId: '',
                normalDetailName: '',
                normalGroupName: '',
                score: '',
                period: '',
                illegalDate: '',
                attach: '',
                enterpriseDetail: {}
            }
        },
        created () {
             sessionStorage.removeItem('scoreDetails')
            // console.log(this.$route.query)
            // 测试：初始化企业ID（由上个页面传过来的）
            this.enterpriseId = this.$route.query.id;
            this.enterpriseGradeId = this.$route.query.data.enterpriseGradeId
            // console.log(this.enterpriseGradeId)
            this.getNewDeductList();
            this.getEnterpriseDetail();
            // this.getCause()
            // this.getDetail()
        },
        mounted () {
            this.$on('fileUploadData', val => {//
            console.log(val);
                this.imgUrl = val
            })
        },
        watch: {
            'detailList': {
                handler (val) {
                    this.compickFlag = false;
                    this.$nextTick(() => {
                        this.compickFlag = true;
                    });
                }
            }
        },
        methods: {
            // ICE
            // 通过企业ID获取对应扣分列表，进页面执行
            getNewDeductList () {
                let data = {
                    enterpriseId: this.enterpriseId
                };
                api.newDeduct(data).then(res => {
                    this.list = res.data;
                    console.log(this.list)
                    // console.log('这是对应扣分列表')
                    // console.log(res)
                })
            },
            // 获取企业详情
            getEnterpriseDetail () {
                let data = {
                    enterpriseId: this.enterpriseId
                };
                api.enterpriseDetail(data).then(res => {
                    // console.log('这是对应企业详情')
                    // console.log(res)
                    this.enterpriseDetail = res.data
                })
            },
            // 单选按钮事件
            handleClickRadio (index, radioName) {
                this.radio = radioName; // 修改单选按钮name
                this.normalGroupName = radioName;
                this.listIndex = index; // 获取选中数据条下标（用于修改第二项）
                // console.log(index,radioName)
            },
            // 调起扣分原因选择
            suitCause () {
                this.show = true
            },
            // 扣分原因弹窗确认
            submitTabBtn () {
                // ICE 修改
                let arr = [];
                let resArr = this.list[this.listIndex].items;
                this.markType = '';
                this.markNum = ''
                this.markCause = this.radio;
                for (let i = 0, length = resArr && resArr.length; i < length; i++) {
                    arr[i] = {}
                    arr[i].text = resArr[i].content;
                    arr[i].value = i;
                }
                this.detailList = [arr];
                this.show = false
            },
            // 详细类型
            suitType () {
                if (!this.markCause || this.markCause === '') {
                    this.$Toast({
                        message: '请先选择扣分原因',
                        forbidClick: true
                    })
                } else {
                    this.$refs.commonPicker2.showPicker();
                }
            },
            typeListDetail (val) {
                // console.log(val);
                // console.log(this.list[this.listIndex].items[val[0].value])
                this.markNum = this.list[this.listIndex].items[val[0].value].score;
                this.normalDetailId = this.list[this.listIndex].items[val[0].value].normalDetailId;
                this.normalDetailName = this.list[this.listIndex].items[val[0].value].content;
                this.score = this.list[this.listIndex].items[val[0].value].score;
                this.period = this.list[this.listIndex].items[val[0].value].period;
                this.markType = val[0].text
            },
            // 时间日期
            suitDay () {
                this.$refs.timePick.showPicker();
            },
            getTimeValue (val) {
                this.markDay = val;
                this.illegalDate = val
            },
            // 提交按钮
            submitBtn () {
                //  let attachs = [...this.imgUrl];
                //     if (attachs) {
                //         attachs.map(item => { delete item.url })
                //     }

                if (this.markCause === '' || this.markType === '' || this.markDay === '' || this.markNum === '' || this.message === '') {
                    // if(false){
                    // console.log('不能为空')
                    this.message += '.';
                    this.message = '';
                    this.$Toast({
                        duration: 2000,
                        message: '请正确填写资料',
                        forbidClick: true
                    })
                } else {
                    let attachs = [...this.imgUrl];
                    if (attachs) {
                        attachs.map(item => { delete item.url })
                    }
                    // let attachs=[];
                    // if(this.imgUrl.length>0){
                    //     this.imgUrl.map(item=>{
                    //         attachs.push(item.url);
                    //     })
                    // }
                    
                    let data = {
                        enterpriseGradeId: this.enterpriseGradeId,
                        normalDetailId: this.normalDetailId,
                        normalDetailName: this.normalDetailName,
                        normalGroupName: this.normalGroupName,
                        score: this.score,
                        period: this.period,
                        illegalDate: this.illegalDate,
                        attach: JSON.stringify(attachs),
                        remark: this.message
                    }
                    this.$Toast.loading({
                        duration: 0,
                        message: '提交中',
                        forbidClick: true
                    })
                    api.create(data).then(res => {
                        if (res.ret !== 0) {
                            this.$Toast.clear();
                            this.$Toast({
                                duration: 2000,
                                message: '提交失败',
                                forbidClick: true
                            })
                        } else {
                            let param1 = {
                                id: this.enterpriseId,
                            }
                            let param2 = {
                                fromPage: 'addMrks',
                                message: '新增扣分成功'
                            }

                            this.message = '';
                            this.$Toast.clear();
                            // this.$Toast.success('新增扣分成功');
                            let state = {
                                success: false,
                                msg: '下线成功'
                            }
                            state = JSON.stringify(state)
                            localStorage.setItem('referraState', state)
                            sessionStorage.setItem('scoreDetails', JSON.stringify(param2))
                            this.$router.push({ path: 'scoreDetails', query: param1 })
                        }
                    })
                }
            },
            // 时间选择器
            getDate (value) {
                this.markDay = value;
                this.illegalDate = value;
                this.isShowTimePicker = false
            },
            showDatePicker () {
                this.isShowTimePicker = true
            },
            // 关闭时间选择器
            cancelDatePick (val) {
                this.isShowTimePicker = val
            }
        }
    }
</script>

<style lang="less" scoped>
    .markWap{
        width: 100%;
        background: #fff;
        padding-bottom:12px;
        .markWapTopBox{
            min-height: 100px;
            padding: 20px 12px 24px 12px;
            background-color: #fff;
            font-size:0;
            .title{
                font-size: 16px;
                font-weight: bold;
                line-height: 1.3em;
            }
            .bagesBox::after{
                content: '';
                display: block;
                clear: both;
            }

            .bagesBox{
                display:flex;
                flex-direction: row;
                align-items: center;
                margin-top:14px;
                margin-left:-2px;
                >div{
                    padding: 2px 4px;
                    font-size: 11px;
                    transform: scale(0.9);
                    text-align: center;
                }
                .localBage{
                    color: #2283E6;
                    border:1px solid #2283E6;
                }
                .industryBage{
                    color: #36B374;
                    border:1px solid #36B374;
                }
            }

        }
        .markList{
            width:100%;
            padding:0 12px;
            .markItem{
                width:100%;
                padding: 15px 0;
                font-size: 14px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .markTitle{
                    min-width: 62px;
                    color:#999;
                    font-size:14px;
                    span{
                        color: red;
                    }
                }
                .markSelect{
                    color: #999;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    .item{
                        width:100%;
                        max-width: 266px;
                        overflow: hidden;
                        white-space:nowrap;
                        text-overflow:ellipsis;
                        span{
                            color: #999;
                            margin-left: 6px;
                            font-size:14px;
                        }
                        .markColor{
                            color: #000;
                            width: 150px;
                            text-align: right;
                            margin-right: 8px;
                            overflow: hidden;
                            text-overflow:ellipsis;
                            white-space: nowrap;
                            font-size:14px;
                            vertical-align: bottom;
                        }
                    }
                    .icon_right{
                        width:12px;
                        height:12px;
                    }
                    .markColor{
                        color: #000;
                        width: 150px;
                        text-align: right;
                        margin-right: 8px;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                        font-size:14px;
                        vertical-align: bottom;
                    }
                    .markSelectItem{
                        margin-right: 10px;
                    }
                }
            }
        }
        .markDetail{
            width:100%;
            padding: 16px 12px 12px 12px;
            height: 100%;
            .markTitle{
                font-size: 14px;
                color:#999;
            }
            .markRemack{
                padding-top: 12px;
                width:100%;
                .markRemackBox{
                    width:100%;
                    border:0;
                    padding:16px;
                    box-sizing: border-box;
                    outline: none;
                    background-color: #F9F9F9;
                    height:180px;
                    border-radius: 3px;
                    font-size:14px;
                }
            }
        }
        .markUpload{
            height: 100%;
            margin: 0 12px;
            .markUploadTitle{
                font-size: 14px;
                margin-top: 20px;
                height: 50px;
            }
            .markFuil{

                margin-top: 10px;
            }
        }
        .btnWap{
            margin: 0 12px;
            background: #36B374;
            height: 50px;
            line-height: 50px;
            border-radius: 3px;

            .submitBtn{
                text-align: center;
                font-size: 16px;
                color: #fff;
            }
        }
    }
    .popWap{
        height: 40%;
        padding-top: 2px;

        .radioGroupBox{
            // width: 100%;
            height: 75%;
            // padding: 8px 12px 0 ;
            padding: 16px 0;
            overflow-y: scroll;
            // .popBox{

            // }
        }
        .btnWap{
            position: fixed;
            bottom: 10px;
            left: 0;
            width: 94%;
            background: #36B374;
            height: 50px;
            line-height: 50px;
            border-radius: 3px;
            .submitBtn{
                text-align: center;
                font-size: 14px;
                color: #fff;
            }
        }
    }
</style>
